import {API_ADMIN_URL} from '../../../config/constants'
import { postRequest } from '../../API'

/*********************************************************
* Function Name : List
* Description   : Get list of all wallet's statement
* By            : Afsar Ali
* Date          : 29-01-2025
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}logs/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function